export default __webpack_public_path__ + "static/media/in-review.7b5b1fd6.svg";